// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteButton__root___1I6m9"};